import { foldToAsciiForXeroTrackingInputTrimmed } from '@gh/core-util';

import { AddressComponents } from './types';

export function foldAddressComponentsForXero(components: AddressComponents): AddressComponents {
  const fold = foldToAsciiForXeroTrackingInputTrimmed;
  return {
    ...components,
    streetNo: fold(components.streetNo),
    street: fold(components.street),
    city: fold(components.city),
    state: fold(components.state),
    stateName: fold(components.stateName),
    postalCode: fold(components.postalCode),
    country: fold(components.country),
  };
}
